// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"3af1a8f7","494":"5e9b5f84","845":"e69a05ae"}[chunkId] + ".chunk.js";
};